import React from 'react';
import { DateInput, TextInput, EnumDropdown, ClearAfterUnmountWrapper, LEGAL_ENTITY } from 'framework/form';
import ConditionalWrapper from 'domain/finance/vendors/shared/components/ConditionalWrapper';
import { VENDOR_DURACTION_TYPE_VALUES, AGREEMENT_TYPES, VENDOR_DURACTION_TYPE } from '../../constants';
import { NoteAttachmentUploaderInput } from 'domain/shared/artifact/input';

interface EditAgreementFormProps {
  agreementType?: string;
}

const EditAgreementForm = ({ agreementType }: EditAgreementFormProps) => (
  <>
    <EnumDropdown label="Legal entity" source="legalEntity" options={LEGAL_ENTITY} isRequired />

    <EnumDropdown label="Agreement type" source="agreementType" options={AGREEMENT_TYPES} isRequired />

    <EnumDropdown label="Duration type" source="durationType" options={VENDOR_DURACTION_TYPE_VALUES} isRequired />

    <DateInput label="Start date" source="startDate" isRequired />

    <ConditionalWrapper
      isVisible={(formData: Record<string, unknown>) => formData.durationType !== VENDOR_DURACTION_TYPE.OPEN_ENDED}
    >
      <DateInput label="End date" source="endDate" isRequired />
    </ConditionalWrapper>

    <ConditionalWrapper
      isVisible={(formData: Record<string, unknown>) => formData.durationType === VENDOR_DURACTION_TYPE.OPEN_ENDED}
    >
      <DateInput label="End date" source="endDate" />
    </ConditionalWrapper>

    <ConditionalWrapper
      isVisible={(formData: Record<string, unknown>) => formData.agreementType === AGREEMENT_TYPES.PUBLIC_OFFER}
    >
      <ClearAfterUnmountWrapper>
        <TextInput source="publicOfferLink" label="Public offer link" placeholder="Public offer link" isRequired />
      </ClearAfterUnmountWrapper>
    </ConditionalWrapper>

    <ConditionalWrapper
      isVisible={(formData: Record<string, unknown>) => formData.agreementType === AGREEMENT_TYPES.CONTRACT}
    >
      <ClearAfterUnmountWrapper>
        <NoteAttachmentUploaderInput
          source="signedContractAttachment"
          label="Signed contract attachment"
          isNewDocumentStorage
          isRequired
        />
      </ClearAfterUnmountWrapper>
    </ConditionalWrapper>
  </>
);

export default EditAgreementForm;
